import React from 'react';
import './KycComplete.css';
import PageLayout from './common/PageLayout';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../assets/icons/check.js';

function KycComplete() {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const failed = location.state?.failed === true;

    const navigationProps = {
        showPrevious: false,
        nextLabel: failed ? t('kycFailedButtonRetry') : t('kycCompleteButtonNext'),
        onNext: () => navigate(failed ? '/kyc' : '/aspspsList'),
        align: 'center',
        nextStyleOverride: {
            borderRadius: '8px',
            padding: '14px 40px',
            fontSize: '17px',
            fontWeight: '600',
            width: '100%',
            maxWidth: '360px'
        }
    };

    return (
        <PageLayout currentStep={1} navigationProps={navigationProps}>
            <div className="kyc-complete-content">
                <div className={`kyc-status-icon ${failed ? 'kyc-status-failed' : 'kyc-status-success'}`}>
                    {failed ? (
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.07 12.93a1.5 1.5 0 010 2.12L22.12 20l4.95 4.95a1.5 1.5 0 01-2.12 2.12L20 22.12l-4.95 4.95a1.5 1.5 0 01-2.12-2.12L17.88 20l-4.95-4.95a1.5 1.5 0 012.12-2.12L20 17.88l4.95-4.95a1.5 1.5 0 012.12 0z" fill="#dc2626"/>
                        </svg>
                    ) : (
                        <CheckIcon width={40} height={40} fill="#16a34a" />
                    )}
                </div>

                <h2 className="kyc-complete-title">
                    {failed ? t('kycFailedTitle') : t('kycCompleteTitle')}
                </h2>
                <p className="kyc-complete-desc">
                    {failed ? t('kycFailedDesc') : t('kycCompleteDesc')}
                </p>

                <div className={`kyc-complete-box ${failed ? 'kyc-complete-box-failed' : ''}`}>
                    <div className="kyc-box-label">
                        {failed ? t('kycFailedBoxTitle') : t('kycCompleteBoxTitle')}
                    </div>
                    <ul className="kyc-box-list">
                        {failed ? (
                            <>
                                <li><span className="kyc-box-check failed">✗</span> {t('kycFailedItem1')}</li>
                                <li><span className="kyc-box-check failed">✗</span> {t('kycFailedItem2')}</li>
                                <li><span className="kyc-box-check failed">✗</span> {t('kycFailedItem3')}</li>
                            </>
                        ) : (
                            <>
                                <li><span className="kyc-box-check">✓</span> {t('kycCompleteItem1')}</li>
                                <li><span className="kyc-box-check">✓</span> {t('kycCompleteItem2')}</li>
                                <li><span className="kyc-box-check">✓</span> {t('kycCompleteItem3')}</li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </PageLayout>
    );
}

export default KycComplete;
